import { getKnowledgeBaseShortList } from '../api';
import { useFetch } from './useFetch';

export const useKnowledgeBaseShortList = () => {
  const { data: knowledgeData, loading } = useFetch(async () => {
    const knowledgeBases = await getKnowledgeBaseShortList(null, true);
    return knowledgeBases
      .map(item => ({
        label: item.name,
        value: item.id,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, []);

  return {
    knowledgeData,
    loading,
  };
};
